import log from 'salvo-lite/log'

class CartKlarnaModal {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = {
            event: 'click',
            ...JSON.parse(elem.getAttribute('data-cart-klarna-modal') || '{}')
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        document.addEventListener(this._data.event, e => {
            if (e.target.classList.contains('KlarnaModal__open')) {
                document.body.classList.add('KlarnaModal__show')
            }
        })
    }
}

export default CartKlarnaModal



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CartKlarnaModal.js